import { UiBox, UiListItem, UiTypography } from "@smp/ui";
import format from "date-fns/format";
import { useMemo, useState } from "react";

import { useInterval } from "@/hooks/use_interval";

import { useStyles } from "./time_mock.css";

export const TimeMock = () => {
  const [date, setDate] = useState<Date>(new Date());

  const classes = useStyles();

  const formattedTime = useMemo(() => format(date, "HH:mm"), [date]);

  useInterval(() => {
    setDate(new Date());
  }, 1000);

  return useMemo(
    () => (
      <UiListItem button className={classes.list_item}>
        <UiBox
          alignItems="center"
          display="flex"
          flexDirection="column"
          flexGrow={1}
          justifyContent="center"
          height={40}
        >
          <UiBox alignItems="center" display="flex" justifyContent="center">
            <UiTypography variant="body1">{formattedTime}</UiTypography>
          </UiBox>
        </UiBox>
      </UiListItem>
    ),
    [classes.list_item, formattedTime],
  );
};
